import { render } from "./CarouselSkills.vue?vue&type=template&id=d0d09bc2&scoped=true"
import script from "./CarouselSkills.vue?vue&type=script&lang=js"
export * from "./CarouselSkills.vue?vue&type=script&lang=js"

import "./CarouselSkills.vue?vue&type=style&index=0&id=d0d09bc2&scoped=true&lang=css"

import exportComponent from "/Users/farhad/Hemsidan/fartow-se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0d09bc2"]])

export default __exports__